class HeaderMenuFixed {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    const MvSwiper = '.js-mv';

    // ScrollTrigger を作成
    Alpine.store('isHeaderReady', false);
    Alpine.store('isHeaderActive', false);

    ScrollTrigger.create({
      trigger: "body",
      start: "+=200",
      end: "+=500",
      onEnter: () => {
        Alpine.store('isHeaderReady', true);
      },
      onLeaveBack: () => {
        Alpine.store('isHeaderReady', false);
      },
    });
    ScrollTrigger.create({
      trigger: MvSwiper,
      start: 'bottom top',
      end: 'bottom bottom',
      onEnter: () => {
        Alpine.store('isHeaderActive', true);
      },
      onLeaveBack: () => {
        Alpine.store('isHeaderActive', false);
      },
    });
  }
}
